import { SxProps, Theme } from '@mui/material';

export const helpButtonStyles: SxProps<Theme> = {
  position: 'absolute',
  top: -10,
  right: 0,
  zIndex: 1,
};
